import BannerComp from "../../components/BannerComp";
import FeatureFlow from "../../components/FeatureFlow";
import FeatureImageContent from "../../components/FeatureImageContent";
import IconBenefitGrid from "../../components/IconBenefitGrid";
import ImageTextSection from "../../components/ImageTextSection";
import Seo from "../../components/Seo";
import { benefitsData, stepper } from "../../data/inhouselab";
import { createBreadcrumbSchema, createWebPageSchema } from "../../lib/seo";

import section1Image from "./inhouse_section1.webp";
import section2Image from "./inhouse_section2.webp";
import section3Image from "./inhouse_section3.webp";

const seo = {
  title: "Improve Care, Increase Revenue | MIT4Doctors",
  description:
    "MITSI offers a fully equipped in-house lab with no upfront costs. Bill insurance directly, skip third-party labs, and run a compliant lab that boosts revenue.",
  schema: [
    createWebPageSchema({
      path: "/services/in-house-lab-services",
      title: "Improve Care, Increase Revenue",
      description:
        "MITSI offers a fully equipped in-house lab with no upfront costs. Bill insurance directly for diagnostics, no third-party labs needed. We provide all you need to run a compliant, efficient lab. This saves you time and increases revenue.",
    }),
    createBreadcrumbSchema(
      "/services/in-house-lab-services",
      "Improve Care, Increase Revenue",
    ),
  ],
};

export default function InHouseLabServices() {
  return (
    <>
      <Seo
        title={seo.title}
        metaTitle={seo.title}
        description={seo.description}
        canonicalPath="/services/in-house-lab-services"
        schema={seo.schema}
      />
      <BannerComp
        heading="Improve Care, Increase Revenue"
        paragraph="MITSI offers a fully equipped in-house lab with no upfront costs. Bill insurance directly for diagnostics—no third-party labs needed. We provide all you need to run a compliant, efficient lab. This saves you time and increases revenue."
        centered
        BannerBgImg="/img/banners/inhouselab_hero.webp"
      />

      <ImageTextSection
        image={section1Image}
        imageAlt="Process of Our Lab Services"
        imagePosition="left"
        title="Process of Our Lab Services"
        highlightWords="Lab Services"
        icon={true}
        subSections={[
          {
            listItems: [
              "We provide a fully equipped lab suite for immediate use. You don't need to worry about infrastructure or purchasing equipment",
              "We provide the space and fully trained staff to operate the lab. Alternatively, we can offer trained technicians to run the lab, eliminating the need for hiring.",
              "You can bill insurers directly for lab services, as everything is in-house. This increases your practice's revenue potential.",
              "We manage inventory, maintain equipment, and troubleshoot issues. This keeps diagnoses running smoothly.",
            ],
          },
        ]}
      />

      <IconBenefitGrid
        title="Why MITSI Lab Service Solution?"
        description="MITSI Lab Service Solutions provide reliable testing, fast results, and actionable insights to support better patient care."
        highlightWords="Solution?"
        items={benefitsData}
      />

      <FeatureImageContent
        heading="Partner with MITSI Today"
        description="Stop relying on third-party labs. Monitor your diagnostics with MITSI Lab Services Solution. We provide all you need to improve patient care and increase revenue."
        buttonLabel="Get Started"
        buttonUrl="/contact-us"
        imageAlt="Partner with MITSI Today"
      />

      <ImageTextSection
        image={section2Image}
        imageAlt="Who Can Benefit from This Solution?"
        imagePosition="left"
        title="Who Can Benefit from This Solution?"
        description="Our Lab Services solution is ideal for:"
        subSections={[
          {
            listItems: [
              "Primary care practices",
              "Specialty clinics",
              "Urgent care centers",
              "Multidisciplinary healthcare facilities",
            ],
          },
        ]}
        highlightWords="Solution?"
        icon={true}
      />

      <FeatureFlow
        heading="Key Advantage"
        highlights={["Advantage"]}
        paragraph="MITSI provides a complete lab solution that simplifies setup, reduces costs, and supports efficient diagnostic services and better patient care."
        steps={stepper}
      />

      <ImageTextSection
        image={section3Image}
        imageAlt="In-House Labs, Big Impact"
        imagePosition="left"
        title="In-House Labs, Big Impact"
        description="Contact us today to learn how MITSI In-House Lab Services can transform your practice. Ease operations, increase revenue, and deliver faster, more accurate results for your patients. Take control of your diagnostics and enhance patient care with MITSI Lab Service Solution. Dive In Now"
        highlightWords="Big Impact"
        buttonLabel="Get Started"
        buttonUrl="/contact-us"
      />
    </>
  );
}
